"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewSettlement = void 0;
/*
 * @LastEditTime: 2022-07-14 23:00:14
 */
// 入驻
var base_1 = __importDefault(require("../base"));
// config
var BASE_URL = '/shop';
var MERCHANT_SETTLEMENT_HOSTS = {
    production: "https://lbs.kuaishou.com".concat(BASE_URL),
    beta: "https://ll-mfe.staging.kuaishou.com".concat(BASE_URL),
};
var MERCHANT_SETTLEMENT_PAGES = {
    // 选择行业页面
    business: '/v3/shop-select',
    // 资质填写页
    qualification: '/v3/shop-fill-cert',
    // 完善门店信息页
    editPoi: '/v3/shop-identify-poi',
    // 店铺信息
    shopInfo: '/merchant/info',
    // 门店管理（门店列表）
    poiList: '/poi/list',
    // 行业管理（行业列表）
    proxyList: '/proxy/list',
    // 分销者注册成功
    distributeSignUpSuccess: '/distribute/signup/success',
    // 协议
    protocal: '/protocal',
    // 分销协议
    distributeProtocal: '/distribute/protocal',
};
var createNewSettlement = function (jumpOptions) {
    jumpOptions.betaHost && (MERCHANT_SETTLEMENT_HOSTS.beta = jumpOptions.betaHost);
    return new base_1.default({
        host: MERCHANT_SETTLEMENT_HOSTS,
        bridgeQuery: __assign({
            layoutType: 4,
        }, (jumpOptions.bridgeQuery || {})),
        history: true,
        pages: __assign(__assign({}, MERCHANT_SETTLEMENT_PAGES), (jumpOptions.pages || {})),
        baseUrl: BASE_URL,
    });
};
exports.createNewSettlement = createNewSettlement;
var settlement = new base_1.default({
    host: MERCHANT_SETTLEMENT_HOSTS,
    bridgeQuery: {
        // 隐藏原生nav
        layoutType: 4,
    },
    history: true,
    pages: MERCHANT_SETTLEMENT_PAGES,
    baseUrl: BASE_URL,
});
exports.default = settlement;
